import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FaqService } from 'modules/cms/faq/services';
import { FAQS_LIST_KEY } from 'modules/cms/faq/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteFaq = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('faq');
  return useMutation(() => FaqService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries([FAQS_LIST_KEY]);
      queryClient.invalidateQueries([id]);
    },
  });
};
